/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_Free_Plan_NoteInputs */



/**
* | output |
* | --- |
* | "Free plan — no charges" |
*
* @param {Dashboard_Billing_Free_Plan_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_free_plan_note = /** @type {((inputs?: Dashboard_Billing_Free_Plan_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Free_Plan_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kostenloser Plan — keine Gebühren")
	return /** @type {LocalizedString} */ ("Free plan — no charges")
});